export default __webpack_public_path__ + "static/media/L3.jpg";